/* eslint-disable indent */
import styled from 'styled-components';
import variableStyles from '../../../constants/variables-styles';

const StyledStatisticCard = styled.div`
  height: 84px;
  width: 100%;
  background-color: ${variableStyles.primaryWhite};
  box-shadow: 0px 2px 2px rgba(0, 35, 149, 0.08);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;

  .statisticCard-right {
    width: 100%;
    &__title {
      color: ${variableStyles.textSecondary};
      font-size: ${variableStyles.fs14};
      line-height: ${variableStyles.lh22};
    }
  }

  .statisticCard-left {
    i {
      border-radius: 50%;
      background: ${(props) =>
        props['data-background']
          ? props['data-background']
          : variableStyles.iconActive};
      width: 48px;
      height: 48px;
      display: flex;
      font-size: ${variableStyles.fs24};
      color: ${(props) =>
        props['data-color'] ? props['data-color'] : variableStyles.iconActive};
    }
  }

  .subtitle-1 {
    margin-top: 4px;
  }
`;

export { StyledStatisticCard };
